import type { OS } from 'types';

import braze from '~/services/braze.client';
import faceboook from '~/services/facebook.pixel';
import gtm from '~/services/gtm.client';
import tiktok from '~/services/tiktok.pixel';
import twitter from '~/services/twitter.pixel';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  legacyId: string;
  os: OS;
  pagePosition: string;
  productName: string;
};

class SetNotificationEvent extends UserEvent<EventData> {
  sendToTikTok() {
    return tiktok.fireEvent('NotifyMeSet');
  }

  sendToFacebook() {
    return faceboook.fireCustomEvent('NotifyMeSet');
  }

  sendToTwitter() {
    return twitter.fireEvent(twitter.EventIds.NotifyMeSet);
  }

  sendToGtm() {
    gtm.pushToDataLayer({
      event: 'notify_me_set',
      page_position: this.data.pagePosition,
      product_name: this.data.productName
    });
  }

  collectServerEvents() {
    this.serverEvents.push({
      data: { legacy_product_id: this.data.legacyId, os: this.data.os },
      type: 'notification_set'
    });
  }

  sendToBraze() {
    braze.logReminderEvent({
      itemId: this.data.legacyId,
      reminded: true
    });

    braze.requestPushPermission();
  }
}

export default SetNotificationEvent;
